// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UpdatePaymentRuleInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /payroll/update_payment_rule/{id}
 *
 * Validates input for updating a payment rule.
 * All fields are optional for partial updates.
 */
import { registerContract } from './validate'

export interface Payroll_UpdatePaymentRuleInput {
amount?: number
description?: string
meta?: string
}

registerContract('Payroll_UpdatePaymentRuleInput', {
  amount:      { type: 'number',  required: false },
  description: { type: 'string',  required: false },
  meta:        { type: 'string',  required: false },
})
